import { render, staticRenderFns } from "./walls.vue?vue&type=template&id=fae638b6&scoped=true"
import script from "./walls.vue?vue&type=script&lang=js"
export * from "./walls.vue?vue&type=script&lang=js"
import style0 from "./walls.vue?vue&type=style&index=0&id=fae638b6&prod&scoped=true&lang=css"
import style1 from "./walls.vue?vue&type=style&index=1&id=fae638b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae638b6",
  null
  
)

export default component.exports